import React, { Fragment } from 'react'
import { BaseTable, BaseTableProps } from './components/base-table'
import { ColumnDefinitionInterface } from './types/column-interface'
import { calculateTableTotalWidth } from './utils'

export interface ColumnWithExtraHeaderInterface<T> extends ColumnDefinitionInterface<T> {
  extraHeader: React.ReactNode
}

interface TableWithExtraHeadersProps<T> extends Omit<BaseTableProps<T>, 'columns'> {
  columns: ColumnWithExtraHeaderInterface<T>[]
}

export function TableWithExtraHeaders<T>({ columns, ...props }: TableWithExtraHeadersProps<T>) {
  const tableColumns = columns.map(
    ({ key, header, widthPercent, onRender, onRenderSmall, shouldRender }) => ({
      key,
      header,
      widthPercent,
      onRender,
      onRenderSmall,
      shouldRender,
    }),
  )
  const totalWidth = calculateTableTotalWidth(tableColumns)
  return (
    <div className="overflow-auto">
      <div style={{ minWidth: columns.length * 252 }}>
        <div
          className={`bg-background-secondary main-transition-colors  
          hover:border-brand-primary flex flex-col
          items-start gap-4 rounded-t-lg border border-transparent px-6 py-4 
          lg:flex-row lg:items-center lg:gap-0 lg:p-0
          `}
        >
          {columns.map((column, index) => {
            const widthPercent = column.widthPercent || 25
            return (
              <Fragment key={`extraHeaderCell-${index}`}>
                <div
                  className={`hidden truncate px-6 py-4 lg:table-cell`}
                  style={{
                    flex: `${(widthPercent / totalWidth) * 100}`,
                  }}
                >
                  {column.extraHeader}
                </div>
                <div className={`w-full truncate lg:hidden lg:px-6 lg:py-2.5`}>
                  <div className={`flex items-center gap-3`}>
                    <span className="text-text-primary whitespace-nowrap font-bold">
                      {column.header}
                    </span>
                    {column.extraHeader}
                  </div>
                </div>
              </Fragment>
            )
          })}
        </div>
        <BaseTable columns={tableColumns} {...props} />
      </div>
    </div>
  )
}
